import React from 'react';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import {
  PORTFOLIO_MONITOR_PAGE_TITLE,
  portfolioMonitorImageCaption,
  portfolioMonitorNoAccessDescription,
  portfolioMonitorNoAccessFeatures,
} from '@/creditflowresearch/ui/components/portfolioMonitor/constants';
import image from '@/creditflowresearch/ui/assets/noAccess/portfolioMonitorNoAccess.webp';
import GetStartedButton from '@/creditflowresearch/ui/components/portfolioMonitor/GetStartedButton';

const getPortfolioMonitorOverlay = (isCustomButton, isDesktopOnly = false) => (
  <NoAccessOverlay
    title={ PORTFOLIO_MONITOR_PAGE_TITLE }
    features={ portfolioMonitorNoAccessFeatures }
    description={ portfolioMonitorNoAccessDescription }
    imageCaption={ portfolioMonitorImageCaption }
    image={ image.src }
    customButton={ isCustomButton && GetStartedButton }
    isDesktopOnly={ isDesktopOnly }
  />
);

export default getPortfolioMonitorOverlay;
